import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
const Footer = ({ topRef }) => {
  const handleClick = () => {
    // e.preventDefault();
    topRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div ref={topRef} className="pg-footer">
      <footer className="footer">
        <svg
          className="footer-wave-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 100"
          preserveAspectRatio="none"
        >
          <path
            className="footer-wave-path"
            d="M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z"
          />
        </svg>
        <div className="footer-content">
          <div className="footer-content-column">
            <div className="footer-logo">
              <Link to={"/"} onClick={handleClick} className="footer-logo-link">
                <span className="hidden-link-text">LOGO</span>
                <h1>QSEARCH</h1>
              </Link>
              <div className="footer-call-to-action">
                {/* <h2 className="footer-call-to-action-title"> Email Us</h2> */}
                <span
                  itemProp="address"
                  className="footer-call-to-action-link-wrapper"
                >
                  Near SRM University-Modinagar, Delhi NCR, Meerut Road, pincode - 201204
                </span>
              </div>
            </div>
            <div className="footer-menu">
              {/* <h2 className="footer-menu-name"> Get Started</h2> */}
              <ul id="menu-get-started" className="footer-menu-list">
                <li className="menu-item menu-item-type-post_type menu-item-object-product">
                  {/* <Link to="/">Start</Link> */}
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-product">
                  {/* <Link to="/">Documentation</Link> */}
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-product">
                  {/* <Link to="/">Installation</Link> */}
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-content-column">
            <div className="footer-menu">
              <h2 className="footer-menu-name"> Company</h2>
              <ul id="menu-company" className="footer-menu-list">
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/support">
                    Contact
                  </Link>
                </li>
                <li className="menu-item menu-item-type-taxonomy menu-item-object-category">
                  <Link onClick={handleClick} to="/">
                    posts
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/support">
                    Careers
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-menu">
              <h2 className="footer-menu-name"> Quick Links</h2>
              <ul id="menu-quick-links" className="footer-menu-list">
                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                  <Link
                    onClick={handleClick}
                    rel="noopener noreferrer"
                    to="/support"
                  >
                    Whatsapp Support
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  {/* <Link to="/">Security</Link> */}
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/">
                    Blog
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type_archive menu-item-object-customer">
                  <Link onClick={handleClick} to="/support">
                    Customers
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  {/* <Link to="/">Reviews</Link> */}
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-content-column">
            <div className="footer-menu">
              <h2 className="footer-menu-name"> Legal</h2>
              <ul id="menu-legal" className="footer-menu-list">
                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-170434">
                  <Link onClick={handleClick} to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/shipping-returns">
                    Shipping & Returns
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/cancellation-policy">
                    Cancellation Policy
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/terms-of-use">
                    Terms of Use
                  </Link>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <Link onClick={handleClick} to="/refund-process">
                    Refund process
                  </Link>
                </li>

                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                  <Link
                    onClick={handleClick}
                    rel="noopener noreferrer"
                    to="/support"
                  >
                    Support Center
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-content-column">
            <div className="footer-call-to-action">
              <h2 className="footer-call-to-action-title"> Let's Chat</h2>
              {/* <h2 className="footer-call-to-action-title">Call Us</h2> */}
              <p className="footer-call-to-action-link-wrapper">
                {" "}
                <a
                  className="footer-call-to-action-link"
                  href="tel:+91 8582042402"
                  target="_self"
                >
                  {" "}
                  +91-8582042402{" "}
                </a>
              </p>
            </div>
            <div className="footer-call-to-action">
              {/* <h2 className="footer-call-to-action-title"> Email Us</h2> */}
              <span
                itemProp="email"
                className="footer-call-to-action-link-wrapper"
              >
                <a
                  href="mailto: care@sharepal.in "
                  className="d-flex-center gaps"
                >
                  gauravraj858204@gmail.com
                </a>
              </span>
            </div>

            <div className="footer-call-to-action">
              {/* <h2 className="footer-call-to-action-title"> Let's Chat</h2> */}
              <p className="footer-call-to-action-description">
                {" "}
                Have a support question?
              </p>
              <a
                className="footer-call-to-action-button button"
                href="https://api.whatsapp.com/send?phone=918582042402&text=Hey , I have a query ->"
                target="_self"
              >
                {" "}
                Get in Touch{" "}
              </a>
            </div>
          </div>

          {/* Social media section is below  */}
          {/* <div className="footer-social-links">
            {" "}
            <svg
              className="footer-social-amoeba-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 236 54"
            >
              <path
                className="footer-social-amoeba-path"
                d="M223.06,43.32c-.77-7.2,1.87-28.47-20-32.53C187.78,8,180.41,18,178.32,20.7s-5.63,10.1-4.07,16.7-.13,15.23-4.06,15.91-8.75-2.9-6.89-7S167.41,36,167.15,33a18.93,18.93,0,0,0-2.64-8.53c-3.44-5.5-8-11.19-19.12-11.19a21.64,21.64,0,0,0-18.31,9.18c-2.08,2.7-5.66,9.6-4.07,16.69s.64,14.32-6.11,13.9S108.35,46.5,112,36.54s-1.89-21.24-4-23.94S96.34,0,85.23,0,57.46,8.84,56.49,24.56s6.92,20.79,7,24.59c.07,2.75-6.43,4.16-12.92,2.38s-4-10.75-3.46-12.38c1.85-6.6-2-14-4.08-16.69a21.62,21.62,0,0,0-18.3-9.18C13.62,13.28,9.06,19,5.62,24.47A18.81,18.81,0,0,0,3,33a21.85,21.85,0,0,0,1.58,9.08,16.58,16.58,0,0,1,1.06,5A6.75,6.75,0,0,1,0,54H236C235.47,54,223.83,50.52,223.06,43.32Z"
              />
            </svg>
            <Link
              className="footer-social-link linkedin"
              to="/"
              target="_blank"
            >
              <span className="hidden-link-text">Linkedin</span>
              <svg
                className="footer-social-icon-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
              >
                <path
                  className="footer-social-icon-path"
                  d="M9,25H4V10h5V25z M6.501,8C5.118,8,4,6.879,4,5.499S5.12,3,6.501,3C7.879,3,9,4.121,9,5.499C9,6.879,7.879,8,6.501,8z M27,25h-4.807v-7.3c0-1.741-0.033-3.98-2.499-3.98c-2.503,0-2.888,1.896-2.888,3.854V25H12V9.989h4.614v2.051h0.065 c0.642-1.18,2.211-2.424,4.551-2.424c4.87,0,5.77,3.109,5.77,7.151C27,16.767,27,25,27,25z"
                />
              </svg>
            </Link>
            <Link className="footer-social-link twitter" to="/" target="_blank">
              <span className="hidden-link-text">Twitter</span>
              <svg
                className="footer-social-icon-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 26 26"
              >
                <path
                  className="footer-social-icon-path"
                  d="M 25.855469 5.574219 C 24.914063 5.992188 23.902344 6.273438 22.839844 6.402344 C 23.921875 5.75 24.757813 4.722656 25.148438 3.496094 C 24.132813 4.097656 23.007813 4.535156 21.8125 4.769531 C 20.855469 3.75 19.492188 3.113281 17.980469 3.113281 C 15.082031 3.113281 12.730469 5.464844 12.730469 8.363281 C 12.730469 8.773438 12.777344 9.175781 12.867188 9.558594 C 8.503906 9.339844 4.636719 7.246094 2.046875 4.070313 C 1.59375 4.847656 1.335938 5.75 1.335938 6.714844 C 1.335938 8.535156 2.261719 10.140625 3.671875 11.082031 C 2.808594 11.054688 2 10.820313 1.292969 10.425781 C 1.292969 10.449219 1.292969 10.46875 1.292969 10.492188 C 1.292969 13.035156 3.101563 15.15625 5.503906 15.640625 C 5.0625 15.761719 4.601563 15.824219 4.121094 15.824219 C 3.78125 15.824219 3.453125 15.792969 3.132813 15.730469 C 3.800781 17.8125 5.738281 19.335938 8.035156 19.375 C 6.242188 20.785156 3.976563 21.621094 1.515625 21.621094 C 1.089844 21.621094 0.675781 21.597656 0.265625 21.550781 C 2.585938 23.039063 5.347656 23.90625 8.3125 23.90625 C 17.96875 23.90625 23.25 15.90625 23.25 8.972656 C 23.25 8.742188 23.246094 8.515625 23.234375 8.289063 C 24.261719 7.554688 25.152344 6.628906 25.855469 5.574219 "
                />
              </svg>
            </Link>
            <Link className="footer-social-link youtube" to="/" target="_blank">
              <span className="hidden-link-text">Youtube</span>
              <svg
                className="footer-social-icon-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 30 30"
              >
                <path
                  className="footer-social-icon-path"
                  d="M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z"
                />
              </svg>
            </Link>
            <Link className="footer-social-link github" to="/" target="_blank">
              <span className="hidden-link-text">Github</span>
              <svg
                className="footer-social-icon-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
              >
                <path
                  className="footer-social-icon-path"
                  d="M 16 4 C 9.371094 4 4 9.371094 4 16 C 4 21.300781 7.4375 25.800781 12.207031 27.386719 C 12.808594 27.496094 13.027344 27.128906 13.027344 26.808594 C 13.027344 26.523438 13.015625 25.769531 13.011719 24.769531 C 9.671875 25.492188 8.96875 23.160156 8.96875 23.160156 C 8.421875 21.773438 7.636719 21.402344 7.636719 21.402344 C 6.546875 20.660156 7.71875 20.675781 7.71875 20.675781 C 8.921875 20.761719 9.554688 21.910156 9.554688 21.910156 C 10.625 23.746094 12.363281 23.214844 13.046875 22.910156 C 13.15625 22.132813 13.46875 21.605469 13.808594 21.304688 C 11.144531 21.003906 8.34375 19.972656 8.34375 15.375 C 8.34375 14.0625 8.8125 12.992188 9.578125 12.152344 C 9.457031 11.851563 9.042969 10.628906 9.695313 8.976563 C 9.695313 8.976563 10.703125 8.65625 12.996094 10.207031 C 13.953125 9.941406 14.980469 9.808594 16 9.804688 C 17.019531 9.808594 18.046875 9.941406 19.003906 10.207031 C 21.296875 8.65625 22.300781 8.976563 22.300781 8.976563 C 22.957031 10.628906 22.546875 11.851563 22.421875 12.152344 C 23.191406 12.992188 23.652344 14.0625 23.652344 15.375 C 23.652344 19.984375 20.847656 20.996094 18.175781 21.296875 C 18.605469 21.664063 18.988281 22.398438 18.988281 23.515625 C 18.988281 25.121094 18.976563 26.414063 18.976563 26.808594 C 18.976563 27.128906 19.191406 27.503906 19.800781 27.386719 C 24.566406 25.796875 28 21.300781 28 16 C 28 9.371094 22.628906 4 16 4 Z "
                />
              </svg>
            </Link>
          </div> */}
        </div>
        <div className="footer-copyright">
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright-text">
              {/* <Link className="footer-copyright-link" to="/" target="_self">
                {" "}
                ©{new Date().getFullYear()}. | Designed By: Gaurav Raj. | All
                rights reserved.{" "}
              </Link> */}
              <Link className="footer-copyright-link" to="/" target="_self">
                {" "}
                ©{new Date().getFullYear()}. | Copyright Qsearch.in | All rights
                reserved.{" "}
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
